import ViewsIcon from 'assets/icons/colorful/ViewsIcon'
import CommentsIcon from 'assets/icons/CommentsIcon'
import EyeIcon from 'assets/icons/EyeIcon'
import LikeIcon from 'assets/icons/LikeIcon'
import PinIcon from 'assets/icons/mono/PinIcon'
import { useElementWidth } from 'hooks/useElementWidth'
import React, { useMemo, useRef } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import Skeleton from 'react-loading-skeleton'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { SocialPost } from 'types/campaign/collaborations'
import { formatNumber } from 'utils/helpers'

interface MediaGridProps {
    media: SocialPost[],
    onNextPage: () => void,
    has_more: boolean,
    onGridItemClick: (post: SocialPost) => void,
    contentLoading: boolean
}
const MediaGrid: React.FC<MediaGridProps> = ({ media, onNextPage, has_more, onGridItemClick, contentLoading }) => {


    const error = useSelector((state: RootState) => state.influencers.mediaError);
    const loading = useSelector((state: RootState) => state.influencers.mediaLoading);
    const gridRowRef = useRef<any>(null);

    const rowWidth = useElementWidth(gridRowRef);

     const colSize = useMemo(() => {
        if(!rowWidth) return 'col-4';
        if(rowWidth >= 520){
            return 'col-3';
        } else if(rowWidth >= 340){
            return "col-4";
        } else {
            return 'col-6'
        }

    }, [rowWidth])


    if (!contentLoading && !media.length) {
        return (
            <div className='d-flex flex-column justify-content-center align-items-center gap-2 no-posts-yet'>
                <span className='no-posts-yet-icon'><i className='bx bx-camera'></i></span>
                <span className='no-posts-yet-txt'>No posts yet!</span>
            </div>
        )
    }

   
    return (
        <InfiniteScroll
            dataLength={media.length}
            next={onNextPage}
            hasMore={has_more}
            loader
            scrollableTarget="scrollableDiv"
        >
            <div id='reels-media' ref={gridRowRef} className='row p-0 m-0 g-1'>
                {
                    media.map((mediaItem, i) => {
                        return (<div className={`${colSize} cursor-pointer`} onClick={() => onGridItemClick(mediaItem)} key={i}>
                            <div className={`img-div media-item bgc-content ${colSize === 'col-3' ? 'lg' : ''}`} style={{ backgroundImage: `url(${mediaItem.thumbnail_url})` }}>
                                <div className='media-analytics'>
                                    <div className="analytics gap-2 flex-wrap">
                                         <span className='d-flex  align-items-center'>
                                            <span className='mdi mdi-eye me-1 text-white'></span>
                                            <span className='analytics-count'>{formatNumber(mediaItem.views_count)}</span>
                                        </span>
                                        <span className='d-flex  align-items-center'>
                                            <LikeIcon className='me-1' />
                                            <span className='analytics-count'>{formatNumber(mediaItem.like_count)}</span>
                                        </span>
                                        <span className='d-flex  align-items-center'>
                                            <CommentsIcon className='me-1' />
                                            <span className='analytics-count'>{formatNumber(mediaItem.comments_count)}</span>
                                        </span>
                                    </div>
                                </div>
                                {
                                    mediaItem.bookmarked === 'y' &&
                                    <span className='pin-icon'><PinIcon /></span>
                                }
                            </div>
                        </div>)
                    })
                }
                {
                    contentLoading && Array.from({ length: 12 }).map((_, i) => <div className={colSize}><Skeleton key={i} className='media-item' /></div>)
                }
                {
                    !loading && error &&
                    <div className="d-flex py-3 mb-5 justify-content-center align-items-center">
                        <button className="theme-btn theme-btn-sm btn-primary-outlined" onClick={onNextPage}>Load More <i className='ms-2 fs-5 bx bx-refresh'></i></button>
                    </div>
                }
            </div>
        </InfiniteScroll>
    )
}

export default MediaGrid